import AxiosProvider from '../../providers/AxiosProvider'
import { ENABLE_CREDENTIALS_FOR_REQUEST } from '../../Constants'

export const getNotificationContent = async () => {
  const reqURL = '/content?contentTypes=popupNotification'

  const beepAxios = AxiosProvider.getBeepAxios()
  const response = await beepAxios.get(reqURL, {
    withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST
  })
  return response.data.content[0].fields
}
